module.exports = __webpack_public_path__ + "images/stickers/taco-confused.2c4f4a2aebe6f6692e5f.png";